<template>
	<div class="graph vital-graph">
		<!-- <ScaleTabs
			v-bind:scale="scale"
			:scales="scales"
			@change="setScale"></ScaleTabs> -->
		<!-- <DatePicker
			v-bind:date="date"
			v-bind:startDate="startDate"
			@previous="previous"
			@next="next"></DatePicker> -->
		<Statistics
			v-if="vitalRangeData.length > 0 && statistics"
			v-bind:statistics="statistics">
		</Statistics>
		<div :is="vitalGraphComponent"
			:height="300"
			 v-bind:data="vitalData"
			 v-bind:startDate="startDate"
			 v-bind:date="date"
			 v-bind:interval="interval"
			 v-bind:binWidth="binWidth"
			 :unit="vitalUnit[vital]">
		</div>
	</div>
</template>

<script>
import Graph from './index'

// Different units for different vital types
const vitalUnit = {
	blood_pressure: 'mm/Hg',
	body_weight: 'lbs',
	body_temperature: 'F',
	stress: '',
	heart_rate: 'beats/min',
	'blood_glucose': 'mg/dL'
}

export default {
	name: 'vital-graph',
	extends: Graph,

	props: {
		/**
		 * @prop 	vital
		 * @type 	String
		 * @desc 	type of vital (BP, Weight, Temparature...)
		 * @required
		 */
		vital: {
			type: String,
			required: true
		}
	},

	data() {
		return {
			vitalUnit
		}
	},

	computed: {
		/**
		 * @function 	vitalData
		 * @desc		Returns the vital data with values respective to each vital
		 */
		vitalData() {
			// For each vital
			return this.data.map((vital) => {
				// Get the recorded time of the vital
				let point = {
					time: (vital.time || vital.created),
					value: vital.value
				}

				if (this.vital === 'blood_pressure') {
					point.value = [
						((vital.value >> 16) & 0xffff),
						(vital.value & 0xffff)
					]
				}

				// Convert celsius to fahrenheit
				if (this.vital === 'body_temperature' && vital.unit == 5) {
					point.value = point.value * 1.8 + 32
				}
				// Convert kg to lb
				if (this.vital === 'body_weight' && vital.unit == 2) {
					point.value = point.value * 2.20462;
				}

				return point
			})
		},

		/**
		 * @function 	vitalRangeData
		 * @desc		Returns the records within 'startDate' and 'date', required for 'Statistics' component
		 */
		vitalRangeData() {
			var start = this.startDate.getTime(),
				end = this.date.getTime()

			return this.vitalData.filter((point) => (start <= point.time && point.time <= end))
		},

		/**
		 * @function 	vitalGraphComponent
		 * @desc		type of graph type respective to the vital
		 */
		vitalGraphComponent() {
			if (this.vital === 'blood_pressure')
				return 'Graph3D'
			else if (this.vital === 'stress')
				return 'BarGraph2D'
			else
				return 'Graph2D'
		},

		/**
		 * @function 	statistics
		 * @desc		finding the statistics of vitals lying in the date range 'startDate' and 'date'
		 */
		statistics() {
			var values = this.vitalRangeData.map((point) => point.value)

			if (this.vital == 'blood_pressure') {
				let range = ([0, 1]).map((i) => ([
					Math.min.apply(null, values.map((v) => v[i])),
					Math.max.apply(null, values.map((v) => v[i]))
				]))

				return [
					{ name: 'SYSTOLIC', value: (range[0][0] == range[0][1]) ? range[0][0] : (range[0][0] + ' - ' + range[0][1]) },
					{ name: 'DIASTOLIC', value: (range[1][0] == range[1][1]) ? range[1][0] : (range[1][0] + ' - ' + range[1][1]) }
				]
			}
			else {
				let range = [ Math.min.apply(null, values), Math.max.apply(null, values) ]

				let stats = [
					{ name: 'MIN', value: Math.round(range[0]) },
					{ name: 'MAX', value: Math.round(range[1]) }
				]

				if (this.vital == 'body_weight' || this.vital == 'stress') {
					stats.push({ name: 'AVG', value: Math.round(values.reduce((a, b) => a + b) / values.length) })
				}

				return stats
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.vital-graph {
	position: relative;
	padding-top: 15px;
}
</style>
